import { AfterViewInit, Component, OnInit } from '@angular/core';
import { User } from '../../components/user/user';
import { ParametersService } from '../../components/parameters/parameters.service';
import { UserManagerService } from '@app/managers';
import { environment } from 'environments/environment';
import { PoeModalService, TranslationService } from '@app/services';
import { Parameters } from '@app/components/parameters/parameters';
import { concatMap, filter, map, zip } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@auth0/auth0-angular';


@Component({
    selector: 'app-profile-overview',
    templateUrl: './profile-overview.component.html',
    styleUrls: ['./profile-overview.component.scss'],
    standalone: false
})
export class ProfileOverviewComponent implements OnInit, AfterViewInit {
    user: User;
    alertMessage = '';
    alertType = '';
    isAlertOpenPasswort = false;

    userProfileFormIsValid: boolean;
    changeClicked = false;
    tmpBusinessType: string;
    changedEmail: string;
    params: Parameters;
    constructor(
        private readonly parametersService: ParametersService,
        private readonly translationService: TranslationService,
        private readonly translateService: TranslateService,
        private readonly userManagerService: UserManagerService,
        private readonly authService: AuthService,
        private readonly modalService: PoeModalService
    ) { }

    ngOnInit(): void {
        this.parametersService.getParametersObservable().subscribe(par => {
            this.params = par;
            this.user = this.params.user;
            if (this.user) {
                this.changedEmail = this.user.email;
            }
        });
    }

    ngAfterViewInit(): void {
        this.parametersService.getParametersObservable()
            .pipe(filter(x => !!x.user)).subscribe(x => {
                this.user = x.user;
                this.changedEmail = x.user.email;
            });
    }

    onDeleteUserClick(): void {
        this.modalService.showConfirmationModal({
            title: this.translationService.translateInstant('DeleteAccount'),
            subtitle: this.translationService.translateInstant('deleteAccountSecondTitle'),
            message: this.translationService.translateInstant('deleteAccountInfoText'),
            confirmText: this.translationService.translateInstant('permanentlyDelete'),
            cancelText: this.translationService.translateInstant('back')
        }).subscribe(response => {
            if (response === true) {
                this.doDeleteUser();
            }
        });
    }

    doDeleteUser() {
        this.userManagerService.deleteUser().subscribe({
            next: () => {
                this.authService.logout({
                    logoutParams: {
                        returnTo: environment.logoutUrl
                    }
                });
            },
            error: _ => {
                alert('Coluld not delete user');
            }
        });
    }

    get isEmailUnchanged(): boolean {
        const email = this.changedEmail?.trim() ?? '';
        return !email || email === (this.user?.email?.trim() ?? '');
    }

    changeEmail() {
        this.changeClicked = true;
    }

    cancelEmailChange(): void {
        this.changedEmail = this.user.email;
        this.changeClicked = false;
    }

    sendChangeEmailRequest() {
        this.userManagerService.changeEmail(this.changedEmail).pipe(
            concatMap(() => zip(
                this.translateService.get('requestSent'),
                this.translateService.get('sendRequestSuccessfully'),
                this.translateService.get('OK')
            )),
            map(([title, message, confirmText]) => ({ title, message, confirmText }))
        ).subscribe(modalContent => {
            this.modalService.showInfoModal(modalContent);
            this.changedEmail = this.user.email;
            this.changeClicked = false;
        });
    }
}
